import styled from 'styled-components'
import { P } from '@mote/ui'
import { mote_primary } from '@mote/config/defaults/colors'

export const Hero = styled.div`
  width: 100%;
  background: #fafafc;
  border-bottom-left-radius: 50% 15%;
  border-bottom-right-radius: 50% 15%;
  transition: all 150ms ease-in;

  @media (max-width: 767px) {
    border-radius: 0;
  }
`

export const PreviewContainer = styled.div`
  overflow: hidden;
  border-width: 2px;
  border-color: rgba(244, 244, 245, 1);
  border-radius: 12px;
  margin-top: 32px;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 640px) {
    display: flex;
    max-width: 100%;
  }
`

export const PreviewBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0px;
  padding: 16px;
  height: 183px;
`

export const PreviewImage = styled.img`
  object-fit: cover;
  min-width: 324px;
  width: 324px;
  height: 183px;
`

export const PreviewLink = styled.a`
  color: ${mote_primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`

export const PreviewTitle = styled.span`
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (min-width: 640px) {
    font-size: 20px;
    line-height: 28px;
  }
`

export const PreviewDescription = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  @media (min-width: 640px) {
    font-size: 16px;
    line-height: 24px;
    white-space: normal;
  }
`

export const ExtensionBox = styled.div`
  align-items: center;
  max-width: 320px;
  padding: 24px;
  margin: 32px auto 32px auto;
  text-align: center;
  border-radius: 12px;
  background-color: ${mote_primary};

  @media (min-width: 640px) {
    justify-content: space-between;
    padding: 40px;
    text-align: left;
    display: flex;
    max-width: 100%;
    gap: 10px;
  }
`

export const Logo = styled.img`
  width: 112px;
`

export const LogoLink = styled.a`
  width: 112px;
`

export const HeroContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`

export const Error = styled.div`
  padding: 40px;
`

export const AudioIssuePrompt = styled.div`
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  margin-top: 8px;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
  color: rgba(172, 10, 232, 1);
`

export const TransitionContainer = styled.div`
  height: 100vh;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const TransitionContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  border-radius: 10px;
  background: #f9f9fb;
  box-shadow: 0 14px 24px 0 rgba(0, 0, 0, 0.14);
  width: 100%;
  max-width: 620px;
  height: 328px;
`

export const TransitionText = styled(P)`
  width: 100%;
  max-width: 474px;
  font-size: 30px;
  line-height: 39px;
  text-align: center;
  margin-top: 32px;
`
